import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoader implements TranslocoLoader {
  private readonly _httpClient = inject(HttpClient);

  getTranslation(langPath: string): Observable<Translation> {
    return this._httpClient.get<Translation>(`/assets/i18n/${langPath}.json`);
  }
}
